import { render, staticRenderFns } from "./TokenForm.vue?vue&type=template&id=142f57df&scoped=true&"
import script from "./TokenForm.vue?vue&type=script&lang=js&"
export * from "./TokenForm.vue?vue&type=script&lang=js&"
import style0 from "./TokenForm.vue?vue&type=style&index=0&id=142f57df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142f57df",
  null
  
)

export default component.exports